import { TENANTS_MAP_VALUE_TO_LABEL } from './constants';
import { createTermsTagsManager } from '../../utils/createTermsTagsManager';

export const tenantTagsManager = createTermsTagsManager({
  jsonQueryKey: 'composition',
  mapValueToLabel: TENANTS_MAP_VALUE_TO_LABEL,
  template: 'Состав съёмщиков: %s',
  id: 'tenant',
});
